// extracted by mini-css-extract-plugin
export default {"container":"UserMatchScores-layout-module__container___PGx4R","body":"UserMatchScores-layout-module__body___XFpzM","content":"UserMatchScores-layout-module__content___RJfDz"};